import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from './auth/Auth';

let auth = new Auth();

const PrivateRoute = ({ component: Component, ...props }) => (
    <Route
        {...props}
        exact
        render={(props) => (auth.isAuthenticated()
            ? !props.match.params.tab ? <Redirect to='/dashboard/dynamic-codes' /> : <Component {...props} />
            : <Redirect to='/' />
        )}
    />
);

export default PrivateRoute;
